import type {LanguageSelectorTranslation} from '../languageSelectorTranslationType';

export const translation: LanguageSelectorTranslation = {
  nav: {
    homeAriaLabel: (ctx) => `${ctx.brand} 익명 채팅 홈`,
    languageButtonLabel: `언어`,
    languageModalTitle: `언어를 선택하세요`,
    languageModalCloseLabel: `언어 메뉴 닫기`,
  },
  languageOptions: {
    'en-US': {
      label: `영어 (미국)`,
      countryCodes: [`US`],
    },
    'en-KE': {
      label: `영어 (케냐)`,
      countryCodes: [`KE`],
    },
    'en-NG': {
      label: `영어 (나이지리아)`,
      countryCodes: [`NG`],
    },
    'en-SG': {
      label: `영어 (싱가포르)`,
      countryCodes: [`SG`],
    },
    'pt-PT': {
      label: `포르투갈어 (포르투갈)`,
      countryCodes: [`PT`],
    },
    'pt-BR': {
      label: `포르투갈어 (브라질)`,
      countryCodes: [`BR`],
    },
    'de-DE': {
      label: `독일어 (독일)`,
      countryCodes: [`DE`],
    },
    'de-AT': {
      label: `독일어 (오스트리아)`,
      countryCodes: [`AT`],
    },
    'de-CH': {
      label: `독일어 (스위스)`,
      countryCodes: [`CH`],
    },
    'es-ES': {
      label: `스페인어 (스페인)`,
      countryCodes: [`ES`],
    },
    'fr-FR': {
      label: `프랑스어 (프랑스)`,
      countryCodes: [`FR`],
    },
    'it-IT': {
      label: `이탈리아어 (이탈리아)`,
      countryCodes: [`IT`],
    },
    'nl-NL': {
      label: `네덜란드어 (네덜란드)`,
      countryCodes: [`NL`],
    },
    'pl-PL': {
      label: `폴란드어 (폴란드)`,
      countryCodes: [`PL`],
    },
    'sv-SE': {
      label: `스웨덴어 (스웨덴)`,
      countryCodes: [`SE`],
    },
    'da-DK': {
      label: `덴마크어 (덴마크)`,
      countryCodes: [`DK`],
    },
    'fi-FI': {
      label: `핀란드어 (핀란드)`,
      countryCodes: [`FI`],
    },
    'no-NO': {
      label: `노르웨이어 (노르웨이)`,
      countryCodes: [`NO`],
    },
    'is-IS': {
      label: `아이슬란드어 (아이슬란드)`,
      countryCodes: [`IS`],
    },
    'ja-JP': {
      label: `일본어 (일본)`,
      countryCodes: [`JP`],
    },
    'ko-KR': {
      label: `한국어 (대한민국)`,
      countryCodes: [`KR`],
    },
    'zh-Hans-CN': {
      label: `중국어 (중국)`,
      countryCodes: [`CN`],
    },
    'yue-Hant-HK': {
      label: `광둥어 (홍콩(중국 특별행정구))`,
      countryCodes: [`HK`],
    },
    'vi-VN': {
      label: `베트남어 (베트남)`,
      countryCodes: [`VN`],
    },
    'th-TH': {
      label: `태국어 (태국)`,
      countryCodes: [`TH`],
    },
    'id-ID': {
      label: `인도네시아어 (인도네시아)`,
      countryCodes: [`ID`],
    },
    'sw-KE': {
      label: `스와힐리어 (케냐)`,
      countryCodes: [`KE`],
    },
    'hi-IN': {
      label: `힌디어 (인도)`,
      countryCodes: [`IN`],
    },
    'bn-BD': {
      label: `벵골어 (방글라데시)`,
      countryCodes: [`BD`],
    },
    'mr-IN': {
      label: `마라티어 (인도)`,
      countryCodes: [`IN`],
    },
    'te-IN': {
      label: `텔루구어 (인도)`,
      countryCodes: [`IN`],
    },
    'fa-IR': {
      label: `페르시아어 (이란)`,
      countryCodes: [`IR`],
    },
    'ur-PK': {
      label: `우르두어 (파키스탄)`,
      countryCodes: [`PK`],
    },
    'pa-PK': {
      label: `펀잡어 (파키스탄)`,
      countryCodes: [`PK`],
    },
    'pcm-NG': {
      label: `나이지리아 피진어 (나이지리아)`,
      countryCodes: [`NG`],
    },
    'ru-RU': {
      label: `러시아어 (러시아)`,
      countryCodes: [`RU`],
    },
    'ar-SA': {
      label: `아랍어 (사우디아라비아)`,
      countryCodes: [`SA`],
    },
    'ar-AE': {
      label: `아랍어 (아랍에미리트)`,
      countryCodes: [`AE`],
    },
    'ar-QA': {
      label: `아랍어 (카타르)`,
      countryCodes: [`QA`],
    },
    'ar-MA': {
      label: `모로코 아랍어 (모로코)`,
      countryCodes: [`MA`],
    },
    'tr-TR': {
      label: `튀르키예어 (튀르키예)`,
      countryCodes: [`TR`],
    },
  },
  languageModal: {
    title: `언어 선택`,
    closeLabel: `언어 메뉴 닫기`,
  },
  languageHint: (ctx) => `계정 없이도 ${ctx.localesCount}+개 언어를 마음껏 넘나들 수 있어요.`,
  readPagePrompt: ({languageLabel}) => `이 페이지를 ${languageLabel}로 읽기.`,
};
